/**
 * Infinite Scroll — Mobile Only
 * Impulse theme compatible. Mobile only (max-width: 768px).
 */

(function () {
  'use strict';

  // Impulse's mobile breakpoint is 768px (769px+ is desktop)
  // Check on load AND guard against defer timing issues
  function isMobile() {
    return window.innerWidth <= 768;
  }

  if (!isMobile()) return;

  var PRODUCT_GRID_SELECTOR = '.collection-grid__wrapper .grid';
  var PAGINATION_SELECTOR   = '.pagination';
  var NEXT_LINK_SELECTOR    = '.pagination .next a';
  var SENTINEL_ID           = 'infinite-scroll-sentinel';
  var SPINNER_ID            = 'infinite-scroll-spinner';

  var isLoading = false;
  var observer  = null;

  function getNextUrl() {
    var link = document.querySelector(NEXT_LINK_SELECTOR);
    return link ? link.href : null;
  }

  function hidePagination() {
    var pagination = document.querySelector(PAGINATION_SELECTOR);
    if (pagination) pagination.style.display = 'none';
  }

  function showPagination() {
    var pagination = document.querySelector(PAGINATION_SELECTOR);
    if (pagination) pagination.style.display = '';
  }

  function createSentinel() {
    var existing = document.getElementById(SENTINEL_ID);
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.id = SENTINEL_ID;
    el.style.cssText = 'height:1px;width:100%;';
    var pagination = document.querySelector(PAGINATION_SELECTOR);
    if (pagination) {
      pagination.parentNode.insertBefore(el, pagination);
    }
    return el;
  }

  function createSpinner() {
    var existing = document.getElementById(SPINNER_ID);
    if (existing) return existing;
    var el = document.createElement('div');
    el.id = SPINNER_ID;
    el.innerHTML = '<div class="infinite-scroll-spinner__dot"></div><div class="infinite-scroll-spinner__dot"></div><div class="infinite-scroll-spinner__dot"></div>';
    el.style.cssText = 'display:none;text-align:center;padding:20px 0;';
    var pagination = document.querySelector(PAGINATION_SELECTOR);
    if (pagination) {
      pagination.parentNode.insertBefore(el, pagination);
    }
    return el;
  }

  function injectStyles() {
    if (document.getElementById('infinite-scroll-styles')) return;
    var style = document.createElement('style');
    style.id = 'infinite-scroll-styles';
    style.textContent = [
      '@keyframes is-bounce {',
      '  0%, 80%, 100% { transform: scale(0); opacity: 0.3; }',
      '  40% { transform: scale(1); opacity: 1; }',
      '}',
      '.infinite-scroll-spinner__dot {',
      '  display: inline-block;',
      '  width: 10px;',
      '  height: 10px;',
      '  margin: 0 4px;',
      '  border-radius: 50%;',
      '  background-color: currentColor;',
      '  animation: is-bounce 1.4s ease-in-out infinite both;',
      '}',
      '.infinite-scroll-spinner__dot:nth-child(1) { animation-delay: -0.32s; }',
      '.infinite-scroll-spinner__dot:nth-child(2) { animation-delay: -0.16s; }',
    ].join('');
    document.head.appendChild(style);
  }

  function reinitImages(container) {
    var imgs = container.querySelectorAll('img');
    imgs.forEach(function (img) {
      img.loading = 'eager';
      if (img.dataset.src && (!img.src || img.src === window.location.href)) {
        img.src = img.dataset.src;
      }
      if (img.dataset.srcset && !img.srcset) {
        img.srcset = img.dataset.srcset;
      }
      if (img.decode) {
        img.decode().catch(function () {});
      }
    });

    var aosEls = container.querySelectorAll('[data-aos]');
    aosEls.forEach(function (el) {
      el.classList.remove('aos-init');
      el.classList.remove('aos-animate');
      requestAnimationFrame(function () {
        el.classList.add('aos-init');
        el.classList.add('aos-animate');
      });
    });

    if (window.AOS && typeof window.AOS.refreshHard === 'function') {
      window.AOS.refreshHard();
    } else if (window.AOS && typeof window.AOS.refresh === 'function') {
      window.AOS.refresh();
    }
  }

  function appendProducts(html) {
    var parser   = new DOMParser();
    var doc      = parser.parseFromString(html, 'text/html');
    var newItems = doc.querySelectorAll(PRODUCT_GRID_SELECTOR + ' > *');
    var grid     = document.querySelector(PRODUCT_GRID_SELECTOR);
    if (!grid || !newItems.length) return;

    var fragment = document.createDocumentFragment();
    newItems.forEach(function (item) {
      fragment.appendChild(item);
    });

    grid.appendChild(fragment);
    reinitImages(grid);
  }

  function updateNextLink(html) {
    var parser     = new DOMParser();
    var doc        = parser.parseFromString(html, 'text/html');
    var newNext    = doc.querySelector(NEXT_LINK_SELECTOR);
    var oldNext    = document.querySelector(NEXT_LINK_SELECTOR);
    var pagination = document.querySelector(PAGINATION_SELECTOR);

    if (newNext) {
      if (oldNext) {
        oldNext.href = newNext.href;
      } else if (pagination) {
        var newPag = doc.querySelector(PAGINATION_SELECTOR);
        if (newPag) pagination.innerHTML = newPag.innerHTML;
        pagination.style.display = 'none';
      }
    } else {
      var sentinel = document.getElementById(SENTINEL_ID);
      if (sentinel) sentinel.remove();
      if (pagination) pagination.style.display = 'none';
    }
  }

  function loadNextPage() {
    var nextUrl = getNextUrl();
    if (!nextUrl || isLoading) return;
    isLoading = true;

    var spinner = document.getElementById(SPINNER_ID);
    if (spinner) spinner.style.display = 'block';

    fetch(nextUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Network error ' + response.status);
        return response.text();
      })
      .then(function (html) {
        appendProducts(html);
        updateNextLink(html);

        var sentinel   = document.getElementById(SENTINEL_ID);
        var pagination = document.querySelector(PAGINATION_SELECTOR);
        if (sentinel && pagination) {
          pagination.parentNode.insertBefore(sentinel, pagination);
        }

        if (!getNextUrl()) {
          if (observer) observer.disconnect();
        }
      })
      .catch(function (err) {
        console.warn('[infinite-scroll] Failed to load next page:', err);
        showPagination();
        var sentinel = document.getElementById(SENTINEL_ID);
        if (sentinel) sentinel.remove();
        if (observer) observer.disconnect();
      })
      .finally(function () {
        isLoading = false;
        var spinner = document.getElementById(SPINNER_ID);
        if (spinner) spinner.style.display = 'none';
      });
  }

  function init() {
    // Double-check mobile at init time (script is deferred, runs after DOM)
    if (!isMobile()) return;

    // No next page — nothing to do
    if (!getNextUrl()) return;

    injectStyles();
    hidePagination();
    var sentinel = createSentinel();
    createSpinner();

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadNextPage();
          }
        });
      },
      { rootMargin: '200px' }
    );

    observer.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();